(function () {
  'use strict';

  var CONFIG = {
    quality: null,
    debug: false,
    delaysMs: [800, 3000, 6000]
  };

  var CART_WRITE = /\/cart\/(add|change|update)(\.js)?(\?|$)/i;
  var SHOPIFY_CDN = /(cdn\.shopify\.com\/s\/files\/|\/cdn\/shop\/files\/)/i;
  var busy = false;
  var timers = [];

  function log() {
    if (CONFIG.debug && window.console) {
      console.log.apply(console, ['[png2jpg]'].concat([].slice.call(arguments)));
    }
  }

  function needsConvert(value) {
    return (
      typeof value === 'string' &&
      /^https?:\/\//i.test(value) &&
      SHOPIFY_CDN.test(value) &&
      /\.png(\?|#|$)/i.test(value) &&
      !/[?&]format=/i.test(value)
    );
  }

  function toJpg(url) {
    var out = url + (url.indexOf('?') === -1 ? '?' : '&');
    if (CONFIG.width) out += 'width=' + CONFIG.width + '&';
    if (CONFIG.quality) out += 'quality=' + CONFIG.quality + '&';
    return out + 'format=jpg';
  }

  function buildPatch(props) {
    var patched = null;
    Object.keys(props || {}).forEach(function (key) {
      if (needsConvert(props[key])) {
        if (!patched) {
          patched = {};
          Object.keys(props).forEach(function (k) { patched[k] = props[k]; });
        }
        patched[key] = toJpg(props[key]);
      }
    });
    return patched;
  }

  function getJSON(url) {
    return fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (r) { return r.json(); });
  }

  function changeLine(key, properties) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: key, properties: properties })
    }).then(function (r) { return r.json(); });
  }

  function scan() {
    if (busy) return Promise.resolve();
    busy = true;

    // Each change to .js updates the line key -> re-reads the cart and processes each line individually.
    function pass(remaining) {
      if (remaining <= 0) return Promise.resolve();
      return getJSON('/cart.js').then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return;
        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          var patched = buildPatch(item.properties);
          if (patched) {
            log('convert line', item.key, patched);
            return changeLine(item.key, patched).then(function () {
              return pass(remaining - 1);
            });
          }
        }
      });
    }

    return pass(20)
      .catch(function (err) { log('error', err); })
      .then(function () { busy = false; });
  }

  function schedule() {
    timers.forEach(clearTimeout);
    timers = CONFIG.delaysMs.map(function (ms) {
      return setTimeout(scan, ms);
    });
  }

  // --- hook fetch ---------------------------------------------------------
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = '';
      try {
        url = typeof input === 'string' ? input : (input && input.url) || '';
      } catch (e) {}
      var result = origFetch.apply(this, arguments);
      if (!busy && CART_WRITE.test(url)) {
        try { result.then(schedule, function () {}); } catch (e) {}
      }
      return result;
    };
  }

  // --- hook XMLHttpRequest (theme/app old) ---------------------------------
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    try {
      if (CART_WRITE.test(String(url))) {
        this.addEventListener('load', function () {
          if (!busy) schedule();
        });
      }
    } catch (e) {}
    return origOpen.apply(this, arguments);
  };

  // --- runs on page load (handles the 'add-to-cart' case via form submission) --------
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(scan, 500); });
  } else {
    setTimeout(scan, 500);
  }

  // --- final check: re-scan immediately before clicking checkout ---------------
  document.addEventListener(
    'click',
    function (e) {
      var el = e.target && e.target.closest
        ? e.target.closest('[name="checkout"], a[href="/checkout"], a[href^="/checkout"]')
        : null;
      if (el) scan();
    },
    true
  );
})();